import { styled } from "@mui/material/styles";
import { Stepper, StepConnector, stepConnectorClasses } from "@mui/material";

export const StyledStepper = styled(Stepper)(({ theme }) => ({
  padding: theme.spacing(2),
  [`& .MuiStepConnector-lineVertical`]: {
    borderColor: theme.palette.common.black,
  },
}));

export const StyledConnector = styled(StepConnector)(({ theme }) => ({
  [`& .${stepConnectorClasses.lineVertical}`]: {
    minHeight: theme.spacing(12),
    borderColor: theme.palette.common.black,
  },
  [`&:first-of-type .${stepConnectorClasses.line}`]: {
    border: "none",
  },
  [theme.breakpoints.up("md")]: {
    marginTop: "-60px",
    marginBottom: "-32px",
    marginLeft: "14px",
  },
  [theme.breakpoints.down("md")]: {
    marginTop: "-125px",
    marginLeft: "-62px",
    marginRight: "-36px",
    minWidth: "80px",
  },
}));
